export class Building {
    name = null;
    code = null;
    description = null;
  }